import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';
import { AuthService } from 'src/app/services/auth.service';
import { ToolsService } from 'src/app/services/tools.service';
import { AnalyticsService } from 'src/app/services/analytics.service';
export class ModalCompleteInformationPage {
    constructor(authService, navParams, toolsService, modalController, analyticsService) {
        this.authService = authService;
        this.navParams = navParams;
        this.toolsService = toolsService;
        this.modalController = modalController;
        this.analyticsService = analyticsService;
        this.analyticsService.AnalyticsServiceModalView('complete-information');
    }
    ngOnInit() {
        let questions = this.navParams.data.questions;
        this.selectQuestions(questions);
        this.additional_questions = this.navParams.data.additional_questions;
        this.questions = this.questions.concat(this.additional_questions);
    }
    selectQuestions(questions) {
        this.questions = questions.map(question => {
            if (question.format === 'select' && question.name === 'gender') {
                question.options.push({ name: 'Otro', value: 'OTHER' });
            }
            if (question.format === 'select' && question.name === 'document_type') {
                question.options.push({ name: 'Cédula de Extranjería', value: 'CE' });
            }
            return question;
        });
    }
    //Function to update profile data
    editUserData() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.toolsService.validateQuestions(this.questions)) {
                yield this.toolsService.showLoader();
                try {
                    if (this.questions.length > 0)
                        yield this.authService.updatePlayerData(this.questions);
                    if (this.additional_questions.length > 0)
                        yield this.authService.updateAdditionalPlayerData(this.additional_questions);
                    this.toolsService.showSuccessToast('Usuario actualizado');
                    this.modalController.dismiss();
                }
                catch (error) {
                    console.error('[PROFILE-PAGE] updateProfileData()', error);
                    this.toolsService.showErrorToast();
                }
                yield this.toolsService.dismissLoader();
            }
            else {
                this.toolsService.showErrorToast("Debes llenar todos los datos para continuar");
            }
        });
    }
    cancelAskInfo() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.authService.cancelAskInformation();
            this.modalController.dismiss();
        });
    }
    closeModal() {
        this.modalController.dismiss();
    }
}
